import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UDate from './formateDate';
export default {
  name: 'date',
  props: {
    // 日程列表
    includeSchedule: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var $t = this.$t;
    return {
      year: UDate.year,
      month: UDate.month,
      // 列表
      tableData: [],
      week: [$t('1121'), $t('1122'), $t('1123'), $t('1124'), $t('1125'), $t('1126'), $t('1127')],
      selectDate: ''
    };
  },
  mounted: function mounted() {
    // 初始化日期
    this.formateDate();
  },
  methods: {
    // 下标数据
    createIndex: function createIndex(row, col) {
      var params = this.tableData[row * 7 + col];
      return params || {};
    },
    // 生成每个日期
    createDateArray: function createDateArray(params) {
      var type = params.type,
        value = params.value;
      if (!type) return '';
      var month = this.month;
      var year = this.year;
      // 格式化当前下标日期
      switch (type) {
        case 'next':
          month++;
          if (month < 0) {
            month = 11;
            year--;
          }
          if (month > 11) {
            month = 0;
            year++;
          }
          break;
        case 'last':
          month--;
          if (month < 0) {
            month = 11;
            year--;
          }
          if (month > 11) {
            month = 0;
            year++;
          }
          break;
      }
      return {
        year: year,
        month: month,
        date: value,
        DateObj: new Date(year, month, value)
      };
    },
    // 生成class
    createClass: function createClass(params) {
      var type = params.type,
        value = params.value;
      if (!type) return '';
      var _this$createDateArray = this.createDateArray(params),
        year = _this$createDateArray.year,
        month = _this$createDateArray.month;
      // 当前日期
      var nowDate = new Date();
      var nYear = nowDate.getFullYear();
      var nMonth = nowDate.getMonth();
      var nDate = nowDate.getDate();
      // 选中日期
      var selectClass = this.isSelectDate(params);
      // 展示spot
      var spot = this.addSpot(params) ? 'select-spots' : '';
      if (selectClass) return "".concat(selectClass, " ").concat(spot);
      // 判断是否为当前日期
      if (Number(year) === nYear && Number(month) === nMonth && Number(value) === nDate) {
        return 'current-date-nums ' + spot;
      }
      // 非选中月日期
      if (type !== 'current') return 'last-date-nums ' + spot;
      return spot;
    },
    // 选中日期class
    isSelectDate: function isSelectDate(params) {
      if (!this.selectDate) return false;
      var _this$createDateArray2 = this.createDateArray(params),
        year = _this$createDateArray2.year,
        month = _this$createDateArray2.month,
        date = _this$createDateArray2.date;
      var nYear = this.selectDate.getFullYear();
      var nMonth = this.selectDate.getMonth();
      var nDate = this.selectDate.getDate();
      // 判断是否为当前日期
      if (Number(year) === nYear && Number(month) === nMonth && Number(date) === nDate) {
        return 'select-date-nums';
      }
    },
    // 点击事件
    handlerClickSelect: function handlerClickSelect(params) {
      var _this$createDateArray3 = this.createDateArray(params),
        year = _this$createDateArray3.year,
        month = _this$createDateArray3.month,
        date = _this$createDateArray3.date;
      this.year = year;
      this.month = month;
      this.formateDate();
      this.selectDate = new Date(year, month, date);
      this.$emit('change', this.selectDate);
    },
    // 添加Spot
    addSpot: function addSpot(params) {
      if (!this.includeSchedule.length) return false;
      var _this$createDateArray4 = this.createDateArray(params),
        year = _this$createDateArray4.year,
        month = _this$createDateArray4.month,
        date = _this$createDateArray4.date;
      var status = this.includeSchedule.some(function (item) {
        var _item$split = item.split('-'),
          _item$split2 = _slicedToArray(_item$split, 3),
          ny = _item$split2[0],
          nm = _item$split2[1],
          nd = _item$split2[2];
        if (Number(ny) === Number(year) && Number(nm - 1) === Number(month) && Number(nd) === Number(date)) {
          return true;
        }
      });
      return status;
    },
    formate: function formate(params) {
      if (params.type && params.type === 'month') return params.value + 1;
      return params.value;
    },
    // 生成列表
    formateDate: function formateDate() {
      // 本月天数
      var dateCount = UDate.getDate({
        year: this.year,
        month: this.month
      });
      var firstDay = UDate.getDay({
        year: this.year,
        month: this.month,
        date: 1
      });
      // 上月天数
      var lastDateCount = UDate.getDate({
        year: this.year,
        month: this.month - 1
      });
      var beforeData = Array.from({
        length: firstDay
      }, function (value, index) {
        return index;
      });
      // 数据生成
      // 上月展示日期
      var lastDate = beforeData.map(function (item, index) {
        return {
          type: 'last',
          value: lastDateCount - index
        };
      }).reverse();
      // 本月展示日期
      var currentDate = Array.from({
        length: dateCount
      }, function (value, index) {
        var num = index + 1;
        return {
          type: 'current',
          value: num < 10 ? "0".concat(num) : num
        };
      });
      // 下月日期展示
      var nextDate = Array.from({
        length: 42 - (lastDate.length + currentDate.length)
      }, function (value, index) {
        var num = index + 1;
        return {
          type: 'next',
          value: num < 10 ? "0".concat(num) : num
        };
      });
      // 生成日期
      this.tableData = [].concat(_toConsumableArray(lastDate), currentDate, nextDate);
    },
    // 切换月份
    switchMonth: function switchMonth(month) {
      this.month = month;
      if (month < 0) {
        this.month = 11;
        this.year -= 1;
      }
      if (month > 11) {
        this.month = 0;
        this.year += 1;
      }
      this.formateDate();
    },
    // 切换年份
    switchYear: function switchYear(year) {
      this.year = year;
      this.formateDate();
    }
  }
};